(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module && module.exports) module.exports = api;
  if (root) root.SubscriptionValidation = api;
})(typeof window !== 'undefined' ? window : null, function () {
  const TYPE_DATALOGGER = 'datalogger';
  const TYPE_STORAGE = 'storage';

  const PATTERNS = {
    [TYPE_DATALOGGER]: {
      serial: /^([0-9]{5}|[0-9]{8})$/,
      soma: /^soma00\d(xp\d{7}|xpn\d{5}|log\d{5})$/i,
    },
    [TYPE_STORAGE]: {
      serial: /^[0-9]{2}[A-Z][0-9]{5}$/i,
      soma: /^soma00\dstor\d{5}$/i,
    },
  };

  const MESSAGES = {
    [TYPE_DATALOGGER]: {
      missing: 'Bitte für jedes Datenlogger-Abo die SOMA- oder Seriennummer des Datenloggers eintragen.',
      both: 'Bitte pro Datenlogger nur die SOMA-Nummer oder die Seriennummer angeben, nicht beide.',
      serial_invalid: 'Seriennummer des Datenloggers ungültig. 5 Ziffern (XP) oder 8 Ziffern (XPN), Beispiel: 20013093',
      soma_invalid:
        'SOMA des Datenloggers ungültig. soma00[1 Ziffer]XP[7 Ziffern], soma00[1 Ziffer]XPN[5 Ziffern] oder soma00[1 Ziffer]LOG[5 Ziffern], Beispiel: soma001XPN01234',
      quantity: 'Pro Datenlogger ein Abo. Bitte die Menge dieser Position auf 1 setzen.',
      in_cart: 'Dieser Datenlogger liegt bereits im Warenkorb.',
      not_found:
        'Zu dieser Nummer wurde kein Datenlogger im MAX.PORTAL gefunden. Bitte prüfen Sie die SOMA- oder Seriennummer.',
    },
    [TYPE_STORAGE]: {
      missing: 'Bitte geben Sie die SOMA- oder Seriennummer ein.',
      both: 'Bitte nur die SOMA-Nummer oder die Seriennummer angeben, nicht beide.',
      serial_invalid: 'Seriennummer ungültig. [2 Ziffern][1 Großbuchstabe][5 Ziffern] Beispiel: 45A67890',
      soma_invalid: 'SOMA ungültig. soma00[1 Ziffer]STOR[5 Ziffern] Beispiel: soma008STOR12345',
      quantity: 'Pro MAX.STORAGE ein Abo. Bitte die Menge dieser Position auf 1 setzen.',
      in_cart: 'Dieser MAX.STORAGE liegt bereits im Warenkorb.',
      not_found:
        'Zu dieser Nummer wurde kein MAX.STORAGE im MAX.PORTAL gefunden. Bitte prüfen Sie die SOMA- oder Seriennummer.',
    },
    duplicate: 'Diese Nummer ist bereits bei einem anderen Abo eingetragen.',
    lookup_failed: 'Die Gerätenummer konnte gerade nicht geprüft werden. Bitte versuchen Sie es in einem Moment erneut.',
    lookup_busy: 'Zu viele Prüfungen in kurzer Zeit. Bitte warten Sie eine Minute und versuchen Sie es erneut.',
  };

  const LOOKUP_PATHS = {
    [TYPE_DATALOGGER]: '/apps/portal/datalogger',
    [TYPE_STORAGE]: '/apps/portal/storage',
  };

  const trim = (value) => (value == null ? '' : String(value)).trim();

  const normaliseSerial = (value) => trim(value).toUpperCase();

  const normaliseSoma = (value) => trim(value);

  const isKnownType = (type) => Boolean(PATTERNS[type]);

  const isValidSerialFor = (type, value) => isKnownType(type) && PATTERNS[type].serial.test(trim(value));

  const isValidSomaFor = (type, value) => isKnownType(type) && PATTERNS[type].soma.test(trim(value));

  const messageFor = (type, code) => (MESSAGES[type] && MESSAGES[type][code]) || MESSAGES[code] || '';

  const problem = (type, code, field) => ({ ok: false, code, field, message: messageFor(type, code) });

  const validateLine = (line) => {
    const type = line.type;
    if (!isKnownType(type)) return { ok: true };

    const serial = normaliseSerial(line.serial);
    const soma = normaliseSoma(line.soma);
    const quantity = Number(line.quantity == null ? 1 : line.quantity);

    if (quantity > 1) return problem(type, 'quantity', 'quantity');
    if (soma && serial) return problem(type, 'both', 'Serial');
    if (!soma && !serial) return problem(type, 'missing', 'SOMA');
    if (soma && !isValidSomaFor(type, soma)) return problem(type, 'soma_invalid', 'SOMA');
    if (serial && !isValidSerialFor(type, serial)) return problem(type, 'serial_invalid', 'Serial');
    return { ok: true };
  };

  const deviceNumber = (line) => {
    const serial = normaliseSerial(line.serial);
    if (serial) return serial;
    return normaliseSoma(line.soma).toUpperCase();
  };

  const findDuplicates = (lines) => {
    const seen = new Map();
    lines.forEach((line, position) => {
      if (!isKnownType(line.type)) return;
      const number = deviceNumber(line);
      if (!number) return;
      if (!seen.has(number)) seen.set(number, []);
      seen.get(number).push(position);
    });
    const duplicates = [];
    seen.forEach((positions) => {
      if (positions.length > 1) duplicates.push(...positions);
    });
    return duplicates.sort((a, b) => a - b);
  };

  const evaluateCart = (lines) => {
    const problems = [];
    lines.forEach((line, position) => {
      const result = validateLine(line);
      if (!result.ok) problems.push({ position, line, code: result.code, field: result.field, message: result.message });
    });
    findDuplicates(lines).forEach((position) => {
      if (problems.some((p) => p.position === position)) return;
      const line = lines[position];
      const field = normaliseSerial(line.serial) ? 'Serial' : 'SOMA';
      problems.push({ position, line, code: 'duplicate', field, message: MESSAGES.duplicate });
    });
    problems.sort((a, b) => a.position - b.position);
    return { ok: problems.length === 0, problems, message: problems.length ? problems[0].message : '' };
  };

  const propertyValue = (properties, name) => {
    if (!properties) return '';
    if (Array.isArray(properties)) {
      const hit = properties.find((p) => p && p.name === name);
      return hit ? hit.value : '';
    }
    return properties[name] == null ? '' : properties[name];
  };

  const linesFromCartPayload = (cart, typeForItem) => {
    const items = (cart && cart.items) || [];
    return items.map((item, index) => ({
      index: index + 1,
      key: item.key,
      type: typeof typeForItem === 'function' ? typeForItem(item) : typeForItem ? typeForItem[item.key] || null : null,
      serial: propertyValue(item.properties, 'Serial'),
      soma: propertyValue(item.properties, 'SOMA'),
      quantity: item.quantity,
    }));
  };

  const evaluateCartPayload = (cart, typeForItem) => evaluateCart(linesFromCartPayload(cart, typeForItem));

  // Existence check against the MAX.PORTAL through the Shopify App Proxy (/apps/portal/...).
  // lookupUrl builds the storefront URL, lookupOutcome turns the proxied answer into a validation result.
  const lookupUrl = (line) => {
    const type = line.type;
    if (!isKnownType(type)) return null;
    const identifier = deviceNumber(line);
    if (!identifier) return null;
    return `${LOOKUP_PATHS[type]}?identifier=${encodeURIComponent(identifier)}`;
  };

  const lookupOutcome = (line, status, body) => {
    const type = line.type;
    const field = normaliseSerial(line.serial) ? 'Serial' : 'SOMA';
    if (status === 429) return { ok: false, code: 'lookup_busy', field, message: MESSAGES.lookup_busy };
    if (status === 400) return problem(type, field === 'Serial' ? 'serial_invalid' : 'soma_invalid', field);
    if (status !== 200 || !body || typeof body !== 'object') {
      return { ok: false, code: 'lookup_failed', field, message: MESSAGES.lookup_failed };
    }
    const found = body.found == null ? body.Found : body.found;
    if (found === true) return { ok: true };
    return problem(type, 'not_found', field);
  };

  const findInCart = (cart, line) => {
    const serial = normaliseSerial(line.serial);
    const soma = normaliseSoma(line.soma).toUpperCase();
    const items = (cart && cart.items) || [];
    const hit = items.find((item) => {
      const itemSerial = normaliseSerial(propertyValue(item.properties, 'Serial'));
      const itemSoma = normaliseSoma(propertyValue(item.properties, 'SOMA')).toUpperCase();
      return (serial && itemSerial === serial) || (soma && itemSoma === soma);
    });
    if (!hit) return { ok: true };
    return { ok: false, code: 'in_cart', field: serial ? 'Serial' : 'SOMA', message: messageFor(line.type, 'in_cart'), item: hit };
  };

  return {
    PATTERNS,
    TYPE_DATALOGGER,
    TYPE_STORAGE,
    MESSAGES,
    normaliseSerial,
    normaliseSoma,
    isKnownType,
    isValidSerialFor,
    isValidSomaFor,
    validateLine,
    findDuplicates,
    evaluateCart,
    linesFromCartPayload,
    evaluateCartPayload,
    findInCart,
    LOOKUP_PATHS,
    lookupUrl,
    lookupOutcome,
  };
});
